const KPaging = {
  page: 0,
  pageSize: 20
};

export default KPaging;
